import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import {
  getGlycerinAvailability,
  getGlycerinOrigin,
  getGlycerinArticleId,
} from '@packages/modules/src/Tracking/helper';
import { GetGlycerinWishlistProductPayloadFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetGlycerinWishlistProductPayloadFragmentFragmentDoc';
import type { GlycerinWishListProduct } from '@packages/tracking';
import { getGlycerinPrice } from '../getGlycerinPrice';

/* GraphQL */ `
  fragment GetGlycerinWishlistProductPayloadFragment on Product {
    akl
    sku
    availability {
      ...GetGlycerinAvailabilityFragment
    }
    price {
      ...GetGlycerinPriceFragment
    }
    ...GetGlycerinArticleIdFragment
  }
`;

export type GetGlycerinWishlistProductPayloadProps = {
  data: FragmentType<typeof GetGlycerinWishlistProductPayloadFragmentFragmentDoc>;
  refSearchParam: string | null;
};

export const getGlycerinWishlistProductPayload = ({
  data,
  refSearchParam,
}: GetGlycerinWishlistProductPayloadProps): GlycerinWishListProduct => {
  const unmaskedData = getFragmentData(GetGlycerinWishlistProductPayloadFragmentFragmentDoc, data);
  const { akl, sku, price, availability } = unmaskedData;

  return {
    productId: akl,
    skuId: sku,
    ...getGlycerinArticleId(unmaskedData),
    ...getGlycerinPrice(price),
    ...getGlycerinAvailability(availability),
    ...getGlycerinOrigin(refSearchParam),
    listPosition: undefined,
  };
};
